export default __webpack_public_path__ + "static/media/deleteIcon.3bde0752.svg";